import { render } from "./SavedListingsPage.vue?vue&type=template&id=268a1b5a&scoped=true"
import script from "./SavedListingsPage.vue?vue&type=script&lang=js"
export * from "./SavedListingsPage.vue?vue&type=script&lang=js"

import "./SavedListingsPage.vue?vue&type=style&index=0&id=268a1b5a&lang=css"
import "./SavedListingsPage.vue?vue&type=style&index=1&id=268a1b5a&lang=css"
import "./SavedListingsPage.vue?vue&type=style&index=2&id=268a1b5a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268a1b5a"]])

export default __exports__